import { Link, Avatar } from '@radix-ui/themes';
import { getBlogAddress, getGravatarImageFullURL } from '../../utils/PageAddressUtil';

export default function PopularBlog({ name, domainName, blogAdminLargeImageURL }) {
    const fallbackText = (name && name.trim().charAt(0).toUpperCase()) || '博';

    return (
        <Link href={getBlogAddress(domainName)} className="redesign-popular-item">
            <Avatar
                radius="full"
                src={getGravatarImageFullURL(blogAdminLargeImageURL)}
                fallback={fallbackText}
            />
            <span className="redesign-popular-name">{name}</span>
        </Link>
    );
}
